import { render } from "./AdminSystem.vue?vue&type=template&id=d3cf8166&scoped=true"
import script from "./AdminSystem.vue?vue&type=script&lang=js"
export * from "./AdminSystem.vue?vue&type=script&lang=js"

import "./AdminSystem.vue?vue&type=style&index=0&id=d3cf8166&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3cf8166"]])

export default __exports__